import lodash from 'lodash';

import type { GradedAssignmentGroupChange } from 'bundles/authoring/grading-formula/models/GradedAssignmentGroup';
import GradedAssignmentGroup from 'bundles/authoring/grading-formula/models/GradedAssignmentGroup';
import type { GradedAssignmentGroupNormalized } from 'bundles/learner-progress/types/GradedAssignmentGroup';

export default (bareGroups: Array<GradedAssignmentGroupNormalized>) => {
  return lodash.entries(bareGroups).reduce(
    (groups, [id, group]) => ({
      [id]: new GradedAssignmentGroup({ ...(group as GradedAssignmentGroupChange), id }),
      ...groups,
    }),
    {}
  );
};
